import message from '../../../../helper/message';

export function getAvailableValuesBasedOnSelection(props) {
  const { appApi, models, selectedModel, attributeName, configuration } = props;
  if (!selectedModel || !attributeName) return [];
  const selectedModelAttr = models[selectedModel].attribute;
  const dependOn = appApi.config.getAttribute(attributeName).dependOn;
  let shouldSkip = true;
  for (let idx = 0; idx < dependOn.length && shouldSkip; ++idx)
    shouldSkip = selectedModelAttr !== dependOn[idx];
  if (shouldSkip) return [];
  const { value } = models[selectedModel];
  return appApi.config
    .getAttributeAvailableValues(attributeName, configuration, value)
    .map(option =>
      Object.assign(option, {
        number: models[selectedModel].children.filter(
          id => models[id].value === option.value
        ).length,
      })
    );
}
export function specialCaseShouldHide(props, attributeName) {
  const { appApi, models, selectedModel, configuration } = props;
  if (!selectedModel) return true;
  const selectedModelAttr = models[selectedModel].attribute;
  const dependOn = appApi.config.getAttribute(attributeName).dependOn;
  if (!dependOn)
    throw new Error(
      `List attribute ${attributeName} needs to be dependent on a attribute!`
    );
  let shouldSkip = true;
  for (let idx = 0; idx < dependOn.length && shouldSkip; ++idx)
    shouldSkip = selectedModelAttr !== dependOn[idx];
  if (shouldSkip) return [];
  const { value } = models[selectedModel];
  const values = appApi.config.getAttributeAvailableValues(
    attributeName,
    configuration,
    value
  );
  return !values.length;
}
export function getBlocksBasedOnSelection(props) {
  const { models, selectedModel, configuration } = props;
  const { attribute: parentAttribute, value: parentValue } = models[
    selectedModel
  ];
  if (configuration[parentAttribute].blocks)
    return configuration[parentAttribute].blocks;

  let blocks;
  try {
    blocks = configuration[parentAttribute][parentValue].find(
      model => model.modelId === selectedModel
    ).blocks;
    if (!blocks) throw new Error();
  } catch (e) {
    message.error(`Couldn't find blocks for ${models[selectedModel].value}!`);
  }
  return blocks;
}

export function getAddonModelIdBasedOnSelection(props) {
  const { selectedModel, attributeName, models } = props;
  if (!selectedModel) return;
  const modelId = models[selectedModel].children.find(
    id => models[id].attribute === attributeName
  );
  return modelId;
}

export function getAddonNameBasedOnSelection(props) {
  const { models } = props;
  const addOnModelId = getAddonModelIdBasedOnSelection(props);
  return addOnModelId ? models[addOnModelId].value : 'None';
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/utils/tools.js